import React from "react";
import { CreditCard, Bank } from "react-bootstrap-icons";
import StyledInteractiveButton from "./styled-interactive-button.tsx";

interface PaymentMethodTabsProps {
  activeTab: 'CARD' | 'ACH';
  onTabChange?: (tab: 'CARD' | 'ACH') => void;
  disabled?: boolean;
}

const PaymentMethodTabs = ({ activeTab, onTabChange, disabled = false }: PaymentMethodTabsProps) => {
  const handleTabClick = (tab: 'CARD' | 'ACH') => {
    if (!disabled && onTabChange) {
      onTabChange(tab);
    }
  };

  return (
    <div 
      className="d-flex gap-2 mb-3"
      style={{ 
        padding: "3px",
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        borderRadius: "8px",
        border: "1px solid rgba(255, 255, 255, 0.08)"
      }}
    >
      <StyledInteractiveButton
        onClick={() => handleTabClick('ACH')}
        disabled={disabled}
        isActive={activeTab === 'ACH'}
        variant="tab"
      >
        <Bank size={16} />
        Bank Transfer
      </StyledInteractiveButton>
      
      <StyledInteractiveButton
        onClick={() => handleTabClick('CARD')}
        disabled={disabled}
        isActive={activeTab === 'CARD'}
        variant="tab"
      >
        <CreditCard size={16} />
        Debit/Credit Card
      </StyledInteractiveButton>
    </div>
  );
};

export default PaymentMethodTabs; 